import { render, staticRenderFns } from "./YA_AboutContact.vue?vue&type=template&id=56553e85&scoped=true"
import script from "./YA_AboutContact.vue?vue&type=script&lang=js"
export * from "./YA_AboutContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56553e85",
  null
  
)

export default component.exports